import { parseHtml } from './htmlParser'

/**
 * @deprecated Use parseHtml instead
 * @see parseHtml
 */
export const html = (html: string) => parseHtml(html)